// src/pages/AllRecipesPage.js
import { useEffect, useState } from "react";
import axios from "axios";
import RecipeCard from "../components/RecipeCard";
import "./AllRecipesPage.css";

const typeOptions = ["Appetizers", "Desserts", "Drinks", "Mains", , "Side Dishes", "Snacks"];
const cuisineOptions = ["Afghani", "American", "Arabian", "Argentine","Armenian", "Asian", "Australian", 
                        "Bangladeshi", "Bhutanese", "British", "Burmese", 
                        "Canadian", "Caribbean", "Chinese", "Colombian", "Cuban", 
                        "Danish", "Dutch", "Egyptian", "Ethiopian", "European", "French", "Fusion",
                        "German", "Greek", "Hawaiian", "Hungarian", 
                        "Indian", "Indonesian", "Irish", "Italian",
                        "Jamaican", "Japanese", "Kazakh", "Kenyan", "Korean", "Latin American", "lebanese", "Lebanese",
                        "Malaysian", "Mauritian", "Middle Eastern", "Mexican", "Mongolian", "Mediterranean", "Moroccan",
                        "Nepalese", "Nigerian", "Norwegian", "Omani", 
                        "Pakistani", "Palestinian", "Philippine", "Polynesian", "Portuguese",
                        "Qatari", "Romanian", "Russian", "Saudi-arabian", "Scandinavian",
                        "Scottish", "Singaporean", "Somali", "South African", "Spanish", "Sri Lankan", "Swedish", "Swiss", "Syrian",
                        "Taiwanese", "Thai", "Tibetan","Tunisian", "Turkish", "Ukrainian", "Uzbek", "Venezuelan", "Vietnamese",
                        "Welsh", "Yemeni", "Zimbabwean", "Other"];
const sortOptions = [
  { label: "Most Recent", value: "recent" },
  { label: "Oldest First", value: "oldest" },
  { label: "A–Z", value: "az" },
];

function AllRecipesPage() {
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCuisine, setSelectedCuisine] = useState("");
  const [selectedSort, setSelectedSort] = useState("recent");
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/recipes/`, {
        params: {
          category: selectedCategory,
          cuisine: selectedCuisine,
          sort: selectedSort,
          page: page,
        },
      })
      .then((res) => {
        setRecipes(res.data.results);
        setHasNext(Boolean(res.data.next));
        setHasPrevious(Boolean(res.data.previous));
      });
  }, [page, selectedCategory, selectedCuisine, selectedSort]);

  return (
    <div className="all-recipes-container">
      <div className="filters">
        <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
          <option value="">All Categories</option>
          {typeOptions.map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        <select value={selectedCuisine} onChange={(e) => setSelectedCuisine(e.target.value)}>
          <option value="">All Cuisines</option>
          {cuisineOptions.map((cuisine) => (
            <option key={cuisine} value={cuisine}>{cuisine}</option>
          ))}
        </select>

        <select value={selectedSort} onChange={(e) => setSelectedSort(e.target.value)}>
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>

      <div className="recipe-grid">
        {recipes.map((recipe) => (
          <RecipeCard key={recipe.id} recipe={recipe} />
        ))}
      </div>

      <div className="pagination-controls">
        <button disabled={!hasPrevious} onClick={() => setPage((p) => p - 1)}>Previous</button>
        <span>Page {page}</span>
        <button disabled={!hasNext} onClick={() => setPage((p) => p + 1)}>Next</button>
      </div>
    </div>
  );
}

export default AllRecipesPage;
